import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import logo from "@/assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <img src={logo} alt="dkonnects logo" className="w-10 h-10 rounded-full object-cover" />
              <div>
                <span className="font-display font-bold text-lg">Dashboard</span>
                <span className="block text-[10px] text-primary-foreground/60 -mt-0.5">Powered by dkonnects</span>
              </div>
            </div>
            <p className="text-sm text-primary-foreground/70 leading-relaxed">
              Connections made simple. Your trusted source for IPO information, financial news, job opportunities, and learning resources.
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li><Link to="/ipos" className="hover:text-primary-foreground transition-colors">IPO Information</Link></li>
              <li><Link to="/ipo-gmp" className="hover:text-primary-foreground transition-colors">IPO GMP Live</Link></li>
              <li><Link to="/news" className="hover:text-primary-foreground transition-colors">Finance News</Link></li>
              <li><Link to="/jobs" className="hover:text-primary-foreground transition-colors">Jobs & Learning</Link></li>
              <li><Link to="/referral" className="hover:text-primary-foreground transition-colors">Refer & Earn</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm text-primary-foreground/70">
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0" />
                <span>CKB Layout, Marathahalli, Bangalore – 560037</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="shrink-0" />
                <span>8500301281</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="shrink-0" />
                <span>dkonnects@outlook.com</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-4">Disclaimer</h4>
            <p className="text-xs text-primary-foreground/50 leading-relaxed">
              The information provided on this website is for informational and educational purposes only. We do not provide investment, financial, legal, or tax advice. Users should consult a qualified advisor before making decisions.
            </p>
          </div>
        </div>

        <div className="border-t border-primary-foreground/10 mt-8 pt-6 text-center text-xs text-primary-foreground/40">
          © {new Date().getFullYear()} Dashboard — Powered by dkonnects. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
